import { render, staticRenderFns } from "./EmpresaCertificado.vue?vue&type=template&id=29faf8d8&scoped=true"
import script from "./EmpresaCertificado.vue?vue&type=script&lang=js"
export * from "./EmpresaCertificado.vue?vue&type=script&lang=js"
import style0 from "./EmpresaCertificado.vue?vue&type=style&index=0&id=29faf8d8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29faf8d8",
  null
  
)

export default component.exports